import { Navigate, Outlet } from 'react-router';

import { useEntitlements } from '@/hooks/use-entitlements';
import type { Feature } from '@/lib/entitlements';

interface Props {
  feature: Feature;
}

/**
 * Redirects away from a tier-gated route when the active business's
 * subscription doesn't include `feature`. Renders nothing while the tier
 * lookup is pending, to avoid a flash-redirect (`useEntitlements` is
 * fail-closed, so `has` would otherwise read false during that window).
 */
export function RequireFeature({ feature }: Props) {
  const { isPending, has } = useEntitlements();

  if (isPending) return null;
  if (!has(feature)) return <Navigate to="/jobs" replace />;

  return <Outlet />;
}
